import { creatorQueryKeys as e } from "./useCreatorQueryKeys.mjs";
import { useInfiniteListQuery as t } from "@maat/store-hooks";
import { creatorApi as n } from "@maat/api-main";
//#region src/creator/useCreatorLinkConversionsQuery.ts
var r = (r) => t({
	queryKey: e.linkConversions(r),
	fetchPage: (e) => n.linkConversions(r, { page: e }),
	key: "conversions",
	enabled: !!r
});
//#endregion
export { r as useCreatorLinkConversionsQuery };
